module.exports = __webpack_public_path__ + "static/img04-d6ba79bee6442dd191dd9c07823b8936.jpg";